import React from 'react';

import {
  STDPage,

} from './style';
import IconsLeft from './IconsLeft';

import IconsRight from './IconsRight';


const HeaderMainIcons = ({pageSelected}) => {

  return (
    <>
      <STDPage >
        <IconsLeft pageSelected={pageSelected}/>
        <IconsRight  pageSelected={pageSelected}/>
      </STDPage>



    </>
  );
};

export default HeaderMainIcons;
